<template>
  <div class="modal fade" id="modalComunicados" tabindex="-1" role="dialog">
    <div :class="`modal-dialog modal-lg `" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
              Comunicados
          </h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"><i class="fa fa-times"></i></span>
          </button>
        </div>
        <div class="modal-body">
            <table id="dtMyReleases" class="table display table-hover table-striped" style="width: 100%">
                <thead>
                    <tr>
                        <th>Assunto</th>
                        <th>Publicado Em</th>
                        <th>Valido Até</th>
                        <th>Ver Comunicado</th>
                    </tr>
                </thead>
                <tbody>
                </tbody>
                <tfoot>
                </tfoot>
            </table>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fas fa-window-close fa-fw"></i> Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>